export default {"src":"/_next/static/media/sphtx.b2642bbf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};